import React, { useState } from "react";
import { Link } from "react-router-dom";
import { StldCardPendenciaDeAprovacaoOptions } from "../../styled-components/StyledCardPendenciaDeAprovacaoOptions.style";
import { ModalTimesheetFinalizar } from "../../components/ModalTimesheetFinalizar";
import api from '../../services/api';
import Flex from '@react-css/flex';

export const CardPendenciaDeAprovacaoOptions = (props) => {
    const {
        item,
        openModalAprovar,
        openModalReprovar,
        openModalTransferir,
        openModalConcluir,
        openHistoricoAprovacoesModal,
        openObservacoesTimesheet,
        openModalASolicitarEsclarecimento,
        openModalTimesheetTimeline,
        openModalVincular,
        openModalTimeSheetExportarPDF
    } = props;

    const [modalTimeshetFinalizarIsOpen, setModalTimeshetFinalizarIsOpen] = useState(false);
    const [finalizarResumo, setFinalizarResumo] = useState({});
    const [timesheet, setTimesheet] = useState({});
    const [finalizarResumoAccess, setFinalizarResumoAccess] = useState({});
    const closeModalTimesheetFinalizar = () => {
        setModalTimeshetFinalizarIsOpen(false);
    }

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const openPlanilhaResumo = async (item) => {
        try {
            const responseTS = await api.get(`Timesheet/load/${item.idTimesheet}?length=10`, config);
            setTimesheet(responseTS.data.data);
            const response = await api.get(`timesheet/${item.idTimesheet}/finalizar`, config);
            setFinalizarResumo(response.data.data);
            setFinalizarResumoAccess(response.data.access);
            setModalTimeshetFinalizarIsOpen(true);
        } catch (err) { }
    }

    const checkPrazo = (item) => {
        if (item.statusAprovacao !== "Pendente") return ""
        var diasPassadosEmPorcentagem = item.diasRestantes * 100 / item.prazo
        if (item.diasRestantes < 0) {
            return "error";
        }
        else if (diasPassadosEmPorcentagem <= 70) {
            return "warning";
        }
        else {
            return "success";
        }
    }

    const formatTexto = (text) => {

        if (text.length >= 40) {
            const listText = [{
                textOriginal: "Aguardando Esclarecimento da  Seguradora",
                textAbrev: "Aguardando Escl. da  Seg."
            },
            {
                textOriginal: "Analisar a Execução de Serviços não Autorizados",
                textAbrev: "Analisar a Exec. de Serv. não Aut.",
            },
            {
                textOriginal: "Analisar o Timesheet não pode ser enviado",
                textAbrev: "Analisar o Ts não pode ser env.",
            },
            {
                textOriginal: "Analisar o Valor do Timesheet é maior que o prejuízo",
                textAbrev: "Analisar o Vl Ts é maior que prej.",
            },
            {
                textOriginal: "Prestar o Esclarecimento a Seguradora (Simples)",
                textAbrev: "Prestar o Escl. a Seg.(Simples)",
            }];


            const textAbrev = listText.find((item) => item.textOriginal === text);


            return textAbrev ? textAbrev.textAbrev : text.substring(0, 30) + "...";
        }

        return text;

    }

    const getClassRow = (row) => {
        return (row.acoes.notificacaoAtividade || row.acoes.notificacaoGrupoAtividade) ? 'notificacaoCard' : row?.acoes?.notificacaoEsclarecimento ? 'esclarecimentoCard' : (row?.atividadesProbono > 0 ? ' probonoCard' : '')
    };

    const getClassRowIndicacao = (row) => {
        return row?.acoes?.indicacao ? 'indicacaoCard' : ''
        //${getClassRowIndicacao(item)}
    }

    let dadosUsuario = JSON.parse(localStorage.getItem("PROFILE_DATA_SISCOPE"));

    return (
        <StldCardPendenciaDeAprovacaoOptions className={`${getClassRow(item)}`}>
            <div className="card-align">
                <Flex>
                    <Flex.Item className="flex-title-left-num-ts">
                        <span className="legend-title-text-bold">{item.timeSheetSigla} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right-num-ts header-items">
                        <span className="legend-title-text"><span className="badge bg-lightblue" >{item.vidaUtil}</span> </span>
                        <a className="menu-link hover" onClick={() => openModalTimesheetTimeline(item)}>
                            <i className="fa fa-calendar">
                            </i>
                        </a>
                        <a className="menu-link hover" onClick={() => openModalASolicitarEsclarecimento(item)} title="Esclarecimento">
                            <i className={item.escalrecimentosEmAberto > 0 ? (item.idusuarioUltimaMsgEscalrecimento == dadosUsuario.idUsuario ? "fa fa-list-ol possui-comentarios" : "fa fa-list-ol possui-comentarios resposta-pendente") : "fa fa-list-ol"}></i>
                        </a>
                        <a className="menu-link hover" onClick={() => openHistoricoAprovacoesModal(item)} title="Histórico Aprovações">
                            <i className="fa fa-history" aria-hidden="true"></i>
                        </a>
                        <a className="menu-link hover" onClick={() => openModalTransferir(item)} title="Transferir Aprovação">
                            <i className="fa fa-exchange"></i>
                        </a>
                        <a className="menu-link hover" onClick={() => openObservacoesTimesheet(item.idTimesheet)} title="Observações">
                            <i className={item.quantidadeComentarios > 0 ? "fa fa-comments-o possui-comentarios" : "fa fa-comments-o"}></i>
                        </a>
                        <Link className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: item.idTimesheet }} title="Detalhes do Timesheet">
                            <i className="fa fa-search fa-rotate-90"></i>
                        </Link>
                        {item.acoes.vincular && (
                            <a className="menu-link hover" onClick={() => openModalVincular(item)} title="Vincular">
                                <i className="fa fa-link"></i>
                            </a>
                        )}
                        <a className="menu-link hover" onClick={() => openModalTimeSheetExportarPDF(item)} title="Exportar PDF">
                            <i className="fa fa-file"></i>
                        </a>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="flex-title-left">
                        <span className="legend-title-text-1"> {item.tipoTimesheet} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className={"legend-time prazo-" + checkPrazo(item)}>
                            {item.dataPrazo} <i className="fa fa-circle" aria-hidden="true"></i>
                        </span>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="flex-title-left">
                        <span className="legend-title-text-1"> {item.nomeEmpresa} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-title-left-50" style={{ width: "100%" }}>
                        <span className="legend-title-text-1" title={item.nomeEtapa}> {formatTexto(item.nomeEtapa)} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right-50">
                        <span className="legend-title-text-1"> {item.statusAprovacao} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-title-left">
                        <span className="legend-title-text"> {item.sigla} </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right-50">
                        <span className="legend-title-text"> {item.disciplina} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left text-max-50">
                        <span className="legend-title-text " title={item.cliente.clienteNome}> {item.cliente.clienteNome} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left text-max-50">
                        <span className="legend-title-text" title={item.segurado.seguradoNome}> {item.segurado.seguradoNome} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="legend-time">{item.horasTimeSheet}</span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="legend-value"> {item.valorTotalDesconto > 0 ? "*" : ""} {item.valorTimesheet} </span>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="flex-column-left">
                        <span className="footer-details"> Horas Lançadas </span>
                    </Flex.Item>
                    <Flex.Item className="flex-column-right">
                        <span className="footer-details"> Valor total </span>
                    </Flex.Item>
                </Flex>
                <Flex>
                    <Flex.Item className="aprovacao-actions">
                        <div className="position-relative pt-1">
                            <input className='default-button-red button-resumo' value='Planilha Resumo' type="button" onClick={() => openPlanilhaResumo(item)} />
                        </div>
                    </Flex.Item>
                </Flex>

                <Flex style={{ marginTop: "10px" }}>
                    <Flex.Item className="flex-column-center">
                        <span className="name-info">{item?.nomeAprovador}</span>
                    </Flex.Item>
                </Flex>

                <br></br>
                <Flex>
                    <Flex.Item className="aprovacao-actions">
                        {
                            item.statusAprovacao == 'Pendente' && item.escalrecimentosEmAberto == 0 && (
                                <div className="position-relative">
                                    {
                                        item.acoes.reprovar && (
                                            <input className='default-button-red button-reprovar' value='Reprovar' type="button" onClick={() => openModalReprovar(item)} />
                                        )
                                    }
                                    {
                                        (item.acoes.aprovar && (!item.acoes.notificacaoAtividade && !item.acoes.notificacaoGrupoAtividade)) && (
                                            <input style={{ marginRight: "10px" }} className='default-button-red button-aprovar' value='Aprovar' type="button" onClick={() => openModalAprovar(item)} />
                                        )
                                    }
                                    {
                                        item.acoes.concluir && (
                                            <input style={{ marginRight: "10px" }} className='default-button-red button-concluir' value='Concluir' type="button" onClick={() => openModalConcluir(item)} />
                                        )
                                    }

                                </div>
                            )
                        }
                    </Flex.Item>
                </Flex>
            </div>
            <ModalTimesheetFinalizar
                isOpen={modalTimeshetFinalizarIsOpen}
                onRequestClose={closeModalTimesheetFinalizar}
                ariaHideApp={false}
                timesheet={timesheet}
                finalizarResumo={finalizarResumo}
                finalizarResumoAccess={finalizarResumoAccess}
                disableButtons={true}
            >
            </ModalTimesheetFinalizar>
        </StldCardPendenciaDeAprovacaoOptions>
    );
};
